import { Thumbnail } from '@/components/Thumbnail';
import viinexService from '@/services/viinex';
import { useCameraValidation } from '../hooks';

interface CameraThumbnailCellProps {
    sourceId: string;
    refreshKey?: number;
}

export function CameraThumbnailCell({
    sourceId,
    refreshKey,
}: CameraThumbnailCellProps) {
    const { live } = useCameraValidation(sourceId);

    const snapshotUrl = viinexService.getCameraSnapshotUrl(sourceId, {
        width: 71,
        height: 40,
    });

    const requestedUrl = refreshKey
        ? `${snapshotUrl}&_t=${refreshKey}`
        : snapshotUrl;

    return (
        <Thumbnail
            variant="image"
            imageSrc={live ? requestedUrl : undefined}
            imageUsesAuth
            size="fill"
            className="h-[40px] w-[71px] shrink-0 rounded-[2px]"
        />
    );
}
